
<h2 class="memic-list__title text-center fw-bld fs-24 m-b-2">Industry Resource Highlights</h2>
<ngx-slick-carousel class="memic-slick-carousel memic-slick-carousel--multi m-b-4"
                    #slickModal="slick-carousel"
                    [config]="slideConfig">
  <div ngxSlickItem *ngFor="let industryHighlight of industryHighlights" class="slide">
      <div class="card memic-block memic-block-highlights">
        <div class="card-body">
          <h3 class="memic-block__header">{{industryHighlight.title}}</h3>
          <div class="memic-block__body">
            {{industryHighlight.subheading}}
          </div>
        </div>
        <div class="card-footer memic-card-footer text-muted">
          <a href="{{industryHighlight.url}}" target="{{industryHighlight.openNewTab ? '_blank' : '_self'}}" class="btn memic-btn-link memic-btn-link--primary pull-right">Read More<i class="fas fa-long-arrow-alt-right m-l-2" aria-hidden="true"></i></a>
        </div>
      </div>
  </div>
</ngx-slick-carousel>
